import { useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { Save, User } from 'lucide-react';
import { api } from '../../../api/client';
import { useAuthStore } from '../../../store/auth';
import { toast } from '../../../lib/toast';

export default function ProfileSection() {
  const user = useAuthStore((s) => s.user);
  const setUser = useAuthStore((s) => s.setUser);

  const [name, setName] = useState(user?.name || '');
  useEffect(() => {
    setName(user?.name || '');
  }, [user?.name]);

  const nameMutation = useMutation({
    mutationFn: (next) => api.put('/api/me/profile', { name: next }).then((r) => r.data),
    onSuccess: (data) => {
      if (data?.user) setUser(data.user);
      toast.success('Profile updated');
    },
    onError: (err) => toast.error(err, 'Could not update profile'),
  });

  const trimmedName = name.trim();
  const nameDirty = trimmedName !== (user?.name || '');

  return (
    <div className="card">
      <div className="section-header">
        <div className="section-title">
          <span className="section-icon">
            <User className="w-4 h-4" />
          </span>
          Profile
        </div>
        {user?.email && (
          <span className="text-xs text-ink-400 font-mono truncate max-w-[40%]">
            {user.email}
          </span>
        )}
      </div>

      <div>
        <label className="label">Display name</label>
        <p className="text-xs text-ink-400 mb-2">
          Shown on white-label reports, audit history, and the activity feed. Your email is
          fixed — contact support to change it.
        </p>
        <div className="flex gap-2">
          <input
            className="input flex-1"
            type="text"
            placeholder="Your name"
            maxLength={100}
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && nameDirty && trimmedName) nameMutation.mutate(trimmedName);
            }}
          />
          <button
            className="btn-primary"
            disabled={nameMutation.isPending || !nameDirty || !trimmedName}
            onClick={() => nameMutation.mutate(trimmedName)}
          >
            <Save className="w-4 h-4" /> {nameMutation.isPending ? 'Saving…' : 'Save'}
          </button>
        </div>
        {!nameDirty && (user?.name || '').length > 0 && (
          <div className="text-xs text-ink-400 mt-2">No unsaved changes</div>
        )}
      </div>
    </div>
  );
}
